import { createFileRoute } from "@tanstack/react-router";

import { BasicInformationPage } from "@/features/profile";

export const Route = createFileRoute("/profile/basic-information")({
  component: BasicInformationPage,
});
